if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class Header extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.headerHeight = this.closest('.shopify-section-group-header-group')?.scrollHeight;
        this.header = this.closest('.header');
        
        document.documentElement.style.setProperty('--header-offset', `${Math.max(this.header.getBoundingClientRect().top, 0) + this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--pdp-gallery-top', `${this.headerHeight + 16}px`);
        
        window.addEventListener('resize', () => {
          this.headerHeight = this.closest('.shopify-section-group-header-group')?.scrollHeight;
          document.documentElement.style.setProperty('--header-offset', `${Math.max(this.header.getBoundingClientRect().top, 0) + this.header.offsetHeight}px`);
        });
        
        window.addEventListener('scroll', () => {
          if ((window.scrollY > this.lastScroll) && (window.scrollY > (this.headerHeight * 2))) {
            this.header.classList.remove('animate-fadeIn');
            this.header.classList.add('animate-fadeOut');
          } else if ((window.scrollY < this.lastScroll) || ((window.scrollY < (this.headerHeight * 2) && this.classList.contains('animate-fadeOut')))) {
            this.header.classList.remove('animate-fadeOut');
            this.header.classList.add('animate-fadeIn');
          }
          
          document.documentElement.style.setProperty('--header-offset', `${Math.max(this.header.getBoundingClientRect().top, 0) + this.header.offsetHeight}px`);

          this.lastScroll = window.scrollY;
        }, { passive: true });
      }
    }
  )
}